import gql from "graphql-tag"
import type { TypedDocumentNode } from "@graphql-typed-document-node/core"

type SearchOrderWorkflowExecutionsQuery = { searchOrderWorkflowExecutions: { total: number } }
type SearchOrderWorkflowExecutionsVariables = {
  from: number
  size: number
  query?: string | null
  sort?: Array<{ field: string; order: string }> | null
  trackTotalHits?: boolean | null
}

const SEARCH_ORDER_WORKFLOW_EXECUTIONS: TypedDocumentNode<
  SearchOrderWorkflowExecutionsQuery,
  SearchOrderWorkflowExecutionsVariables
> = gql`
  query SearchOrderWorkflowExecutions(
    $from: Int!
    $size: Int!
    $query: AWSJSON
    $sort: [SearchSorting!]
    $trackTotalHits: Boolean
  ) {
    searchOrderWorkflowExecutions(
      from: $from
      size: $size
      query: $query
      sort: $sort
      trackTotalHits: $trackTotalHits
    ) {
      total
      hits {
        id
        orderId
        workflowId
        workflowRevision
        revision
        created
        started
        completed
        failed
        updated
      }
    }
  }
`

export default SEARCH_ORDER_WORKFLOW_EXECUTIONS
